import React from 'react';
import UserProfile from '../components/UserProfile';
import './Profile.css';

export default function Profile() {
  return (
    <div className="profile-page">
      <UserProfile />
    </div>
  );
} 